<div class="flex w-full h-full flex-row"
  *ngIf="{employee: authEmployee$ | async, authenticatedUser: authUser$ | async} as data">
  <mat-sidenav-container class="focus-within w-full example-container">
    <mat-sidenav class="sidenav-menu"></mat-sidenav>
    <mat-sidenav-content class="flex-1 flex-col h-full w-full " style="background-color: #F5F5F5;">
      <div *ngIf="!browserControlService.embeddedInXsellerator"
        class="sticky flex top-0 place-content-between place-items-center w-full my-0 responsive-height"
        style="background-color:#FFF;z-index:5;">
        <svc-action-bar class="w-full" [employee]="data.employee" (emitUserLogout)="logout()"
          (emitOpenSettings)="showSettings = !showSettings" [showSettings]="showSettings"
          [authenticatedUser]="data.authenticatedUser"></svc-action-bar>
      </div>
      <div class="flex-1 flex place-content-center place-items-start router-outlet-container">
        <div class="w-full max-w-4xl h-full">
          <router-outlet class="bg-red-700"></router-outlet>
        </div>
      </div>
      <div *ngIf="showSettings" class="settings-overlay">
        <svc-settings></svc-settings>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>